export function todayISO() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d.toISOString().slice(0, 10);
}

export function formatShortDate(iso?: string) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(+d)) return '—';
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

// Local date helpers centralized (avoid per-file variations)
export const toLocalISODate = (d = new Date()) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const localTodayStr = () => toLocalISODate(new Date());

export const localTomorrowStr = () => {
  const t = new Date();
  t.setDate(t.getDate() + 1);
  return toLocalISODate(t);
};

export const startOfWeekSun = (d = new Date()) => {
  const n = new Date(d);
  const diff = n.getDay(); // 0 = Sun
  n.setDate(n.getDate() - diff);
  return new Date(n.getFullYear(), n.getMonth(), n.getDate());
};

export const endOfWeekSat = (d = new Date()) => {
  const s = startOfWeekSun(d);
  s.setDate(s.getDate() + 6);
  return s;
};

export const toLocalShortDateTime = (iso: string) =>
  new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });

// Parse 'YYYY-MM-DD' as a local date (avoid UTC shifting)
export const parseLocalISODate = (s: string): Date => {
  const [y, m, d] = s.split('-').map((n) => parseInt(n, 10));
  return new Date(y, m - 1, d);
};

// Clamp a Date to local midnight for consistent ISO-only usage
export const atLocalMidnight = (d: Date | string) => {
  const x = typeof d === 'string' ? parseLocalISODate(d) : new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};
